export default __webpack_public_path__ + "static/media/star_2.39a18200.svg";